import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '../sass/app.scss'

import Swiper, { Navigation, Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './order-modal';

// init Swiper:
const swiper = new Swiper('.eurocar-ratings', {
    modules: [Navigation, Pagination],
    direction: 'horizontal',
    loop: true,
    autoHeight: true,
    autoplay: {
        waitForTransition: 4000
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        1280: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
});

for (const option of document.querySelectorAll('option')) {
    if (option.textContent.includes('—Please choose an option—')) {
        option.innerHTML = 'Wybierz opcję';
    }
}
